import { render, staticRenderFns } from "./KzsViewCommonSettings.vue?vue&type=template&id=b086e20e"
import script from "./KzsViewCommonSettings.vue?vue&type=script&lang=js"
export * from "./KzsViewCommonSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports